import React, { FC } from 'react';
import { View } from 'react-native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { connect } from 'react-redux';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { getNCFileByPartId } from '@reducers/manufacture';
import { getPartByID } from '@reducers/parts';

interface PartDetailsNCFileEventsActiveProps {
  ncFileId: number | null;
}

const PartDetailsNCFileEventsActiveComponent: FC<PartDetailsNCFileEventsActiveProps> = ({
  getNCFileByPartId,
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
  ncFileId,
}) => {
  const title = useTitle();

  usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    getProductionBatchByPart,
    updateHeaderConfig,
    getPartByID,
    operationsSearch,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <View style={{ flex: 1 }}>
        <NCFileBatchEvents {...{ eventType: NcFileBatchEventType.ACTIVE, ncFileId }} />
      </View>
    </DetailsPageWrapper>
  );
};

const PartDetailsNCFileEventsActive = connect(({ details: { ncFileId } }) => ({ ncFileId }), {
  getNCFileByPartId,
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
})(PartDetailsNCFileEventsActiveComponent);

export { PartDetailsNCFileEventsActive };
